const platform = require('platform');
// reactで将来的には作りたい
// 対話式でフィードバックがあるようにする

// バグ
document.addEventListener('DOMContentLoaded', function() {
  // ダイアログの処理
  var $report = document.querySelector('#wp-admin-bar-mt-admin-report-bug > a');
  var $dialog = document.querySelector('#mt-admin-report-bug-dialog');
  var $close = document.querySelector('#mt-admin-report-bug-dialog__close');
  if ( $report ) {
    $report.addEventListener('click', function(e) {
      e.preventDefault();
      $dialog.showModal();
    });
  }
  if ( $close ) {
    $close.addEventListener('click', function(e) {
      e.preventDefault();
      $dialog.close();
    });
  }
  if ( $dialog ) {
    document.addEventListener('click', function(e) {
      if (e.target === $dialog) {
        $dialog.close();
      }
    });
  }

  // 情報取得 https://env.mount.jp/
  var $browser = document.querySelector('#mt-admin-report-bug-dialog-browser');
  if ( $browser ) {
    $browser.setAttribute('value', platform.os.toString() + '｜' + platform.name + ' ' + platform.version + '｜' + window.navigator.userAgent);
  }
  var $windowSize = document.querySelector('#mt-admin-report-bug-dialog-window-size');
  if ( $windowSize ) {
    var touchDisplayText = '';
    if ( window.ontouchstart !== undefined && navigator.maxTouchPoints > 0 ) {
      touchDisplayText = '｜タッチディスプレイ';
    }
    $windowSize.setAttribute('value', window.innerWidth.toString() + '*' + window.innerHeight.toString() + '（' + window.screen.width.toString() + '*' + window.screen.height.toString() + '）*' + window.devicePixelRatio + touchDisplayText);
  }

  // フォーム送信処理
  var $submit = document.querySelector('#mt-admin-report-bug-dialog-submit');
  if ( $submit ) {
    $submit.addEventListener('click', function(e) {
      var $message = document.querySelector('#mt-admin-report-bug-dialog-message');
      var $form = document.querySelector('#mt-admin-report-bug-dialog-form');
      $message.innerHTML = '';
      e.preventDefault();
      var name = document.querySelector('#mt-admin-report-bug-dialog-name').value;
      var email = document.querySelector('#mt-admin-report-bug-dialog-email').value;
      var url = document.querySelector('#mt-admin-report-bug-dialog-url').value;
      var browser = document.querySelector('#mt-admin-report-bug-dialog-browser').value;
      var windowSize = document.querySelector('#mt-admin-report-bug-dialog-window-size').value;
      var place = document.querySelector('#mt-admin-report-bug-dialog-place').value;
      var status = document.querySelector('#mt-admin-report-bug-dialog-status').value;
      var expected = document.querySelector('#mt-admin-report-bug-dialog-expected').value;
      var action = MT_REPORT_BUG.action;
      var nonce = MT_REPORT_BUG.nonce;
      if ( name && email && place && action && expected ) {
        let params = new URLSearchParams();
        params.append('name', name);
        params.append('email', email);
        params.append('url', url);
        params.append('browser', browser);
        params.append('windowSize', windowSize);
        params.append('place', place);
        params.append('status', status);
        params.append('expected', expected);
        params.append('action', action);
        params.append('nonce', nonce);
        fetch(MT_REPORT_BUG.endpoint, {
          method: 'post',
          body: params,
        }).then(function(res) {
          console.log(res);
          if ( res.status === 200 ) {
            // JSON.parse(res.body).message
            $form.innerHTML = '<div class="mt-admin-report-bug-dialog-success">送信完了しました。</div>';
          } else {
            $message.innerHTML = '<div class="mt-admin-report-bug-dialog-error">エラーが発生しました。<br />誠に恐れ入りますが、メールかお電話にてお問い合わせくださいますようお願いいたします。</div>';
          }
        }).catch(function(err) {
          console.log(err);
          $message.innerHTML = '<div class="mt-admin-report-bug-dialog-error">エラーが発生しました。<br />誠に恐れ入りますが、メールかお電話にてお問い合わせくださいますようお願いいたします。</div>';
        });
      } else {
        // 入力されていない項目あり
        $message.innerHTML = '<div class="mt-admin-report-bug-dialog-error">入力されていない項目があります。</div>';
      }
    });
  }
});


// ページ情報
document.addEventListener('DOMContentLoaded', function() {
  // ダイアログの処理
  var $report = document.querySelector('#wp-admin-bar-mt-admin-report-page-data > a');
  var $dialog = document.querySelector('#mt-admin-report-page-data-dialog');
  var $close = document.querySelector('#mt-admin-report-page-data-dialog__close');
  if ( $report ) {
    $report.addEventListener('click', function(e) {
      e.preventDefault();
      $dialog.showModal();
    });
  }
  if ( $close ) {
    $close.addEventListener('click', function(e) {
      e.preventDefault();
      $dialog.close();
    });
  }
  if ( $dialog ) {
    document.addEventListener('click', function(e) {
      if (e.target === $dialog) {
        $dialog.close();
      }
    });
  }
});
